 function loadPromotionTermsAndConditions(tag) {
    let attempts = 0;
    let visible = false;
    const maxAttempts = 5;
    const intervalId = setInterval(() => {
    const session = sessionStorage.getItem('store'); // Attempt to retrieve the session data
    if (session || attempts >= maxAttempts) {
        clearInterval(intervalId); // Clear the interval if session is found or attempts are exceeded
        if (session) {
            const data = JSON.parse(session);
            const metaobjects = data.data.metaobjects.nodes;

            metaobjects.forEach((element, i) => {
                const tags = element.fields.find(item => item.key === 'tag').value;

                if (tags === tag) {
                    const metaObject = element['fields'].reduce((obj, item) => {
                        obj[item.key] = item.value;
                        return obj;
                    }, {});

                    let isActiveCampaign = false;
                    const showBadge = metaObject.add_badge_to_product_picture;

                    if (metaObject.promotion_start_date && metaObject.promotion_end_date) {
                        const currentDate = new Date();
                        const startDate = new Date(metaObject.promotion_start_date);
                        const endDate = new Date(metaObject.promotion_end_date);
                        isActiveCampaign = currentDate >= startDate && currentDate <= endDate;
                    } else {
                        isActiveCampaign = true; // Always active if no dates are set
                    }

                    if (isActiveCampaign) {
                        
                        createTermsAndCondition(metaObject); // Function to create and append the terms and condition elements
                        return visible;
                    }
                }
            });
        }
    }
    attempts++; // Increment the attempt count
    }, 1000);

    return visible;
 }

 function createAndAppendElement(parent, className, title, content, isHTML = false) {
    const element = document.createElement('div');
    element.className = className;
    element.title = title;
    
    if (isHTML) {
    element.innerHTML = content; // For HTML content
    } else {
    element.textContent = content; // For text content
    }
    parent.appendChild(element);
}

function createTermsAndCondition(metaObject) {
    const newTermsAndCondition = document.createElement('div');
    newTermsAndCondition.className = '';
    
    if (metaObject.badge !== undefined) {
    createAndAppendElement(newTermsAndCondition, 'flex-items', "title", `<div class="mm-badge"><span class="mm-badge-label" title="">${metaObject.badge}</span></div>`, true);
    }

    if (metaObject.description !== undefined) {
    createAndAppendElement(newTermsAndCondition, 'flex-items', "description", `<p class="tw-tracking-normal"><strong>Contenu:</strong> ${metaObject.description}</p>`, true);
    }

    if (metaObject.period !== undefined) {
    createAndAppendElement(newTermsAndCondition, 'flex-items', "period", `<p class="tw-tracking-normal"><strong>Période de l'action:</strong> ${metaObject.period}</p>`, true);
    }
    
    if (metaObject.conditions) {
    createAndAppendElement(newTermsAndCondition, 'flex-items', "conditions", `<p class="tw-tracking-normal"><strong>Conditions: </strong> ${metaObject.conditions}</p>`, true);
    }

    if (metaObject.url) {
    createAndAppendElement(newTermsAndCondition, 'flex-items', "url", `<a target="_blank" href="${metaObject.url}">${metaObject.url_title}</a>`, true);
    }

    const unique_wrapper = document.querySelector('.termscontainer');
    if (unique_wrapper) {
    unique_wrapper.appendChild(newTermsAndCondition);
    }
}